import { render } from "./TalentSearchList.vue?vue&type=template&id=531e2cc6&scoped=true"
import script from "./TalentSearchList.vue?vue&type=script&lang=js"
export * from "./TalentSearchList.vue?vue&type=script&lang=js"

import "./TalentSearchList.vue?vue&type=style&index=0&id=531e2cc6&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e2cc6"]])

export default __exports__